import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://pztmfqtvmghoeqgwvjas.supabase.co'
const supabaseKey = 'sb_publishable_hVzU_eG-Q6cnsiumf1SNkQ_HpxzUIzz'

export const supabase = createClient(supabaseUrl, supabaseKey)
